module.exports = __webpack_public_path__ + "img/食品.bbde0147.png";